/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarTmpBoardRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_tmp_board');
	},
};

export default JiraAiAgentAvatarTmpBoardRelayProvider;
